<template>
  <div class="pointer-events-none fixed z-110">
    <template v-for="(list, pos) in groupedNotifications" :key="pos">
      <TransitionGroup
        v-show="list.length"
        :class="[
          positionClasses[pos],
          'pointer-events-auto fixed flex flex-col gap-4 p-4',
        ]"
        name="notification"
        tag="div"
      >
        <SFToast v-for="n in list" :key="n.id" :notification="n" />
      </TransitionGroup>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { type StorefrontNotification, useNotification } from '#storefront-ui'
import { SFToast } from '#storefront-ui/components'

type Position = NonNullable<StorefrontNotification['position']>
const { notifications } = useNotification()

const positionClasses: Record<Position, string> = {
  top: 'top-4 inset-x-0 items-center',
  bottom: 'bottom-4 inset-x-0 items-center',
  'top-left': 'top-4 left-4 items-start',
  'top-right': 'right-0 !p-0 top-4 md:right-4 md:!p-4 items-end',
  'bottom-left': 'bottom-4 left-4 items-start',
  'bottom-right': 'bottom-4 right-4 items-end',
}

const groupedNotifications = computed<
  Record<Position, StorefrontNotification[]>
>(() => {
  const groups = {} as Record<Position, StorefrontNotification[]>
  for (const pos of Object.keys(positionClasses) as Position[]) {
    groups[pos] = notifications.value.filter((n) => n.position === pos)
  }
  return groups
})
</script>
